import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("p", {
    class: "revico-community-talk-talkroom-details--contents",
    innerHTML: $props.contents
  }, null, 8 /* PROPS */, _hoisted_1))
}